<template>
    <div>
        <div class="modal fade" id="studentGroupStudentsModal" tabindex="-1" role="dialog"
             aria-labelledby="studentGroupStudentsModalLabel" aria-hidden="true"
             @keydown.esc="closeModal">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="studentGroupStudentsModalLabel">{{ trans('messages.Students for') }}
                            {{ studentGroup.name }}</h5>
                        <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body fixed-height">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-inline form-group">
                                    <input class="form-control col-sm-12" type="search" :placeholder="trans('messages.Search')"
                                           aria-label="Search"
                                           v-model="studentsSearch">
                                </div>
                            </div>
                            <div class="col-sm-12 student-name" v-for="(student,idx) in students" :key="idx">
                                <i class="fa fa-user"></i> {{ student.full_name }}
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="closeModal">
                            {{ trans('messages.Close') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "StudentGroupStudentsModal",
    props: {
        studentGroup: Object,
    },
    data: function () {
        return {
            studentsSearch: "",
        }
    },
    computed: {
        searchString() {
            return this.studentsSearch.toLowerCase()
        },
        students() {
            return this.studentGroup.students.filter(student => student.full_name.toLowerCase().indexOf(this.studentsSearch) !== -1)
        }
    },
    mounted() {
        // console.log(this.studentGroup)
        $('#studentGroupStudentsModal').modal({backdrop: 'static', keyboard: true})
        $('#studentGroupStudentsModal').modal('show');
    },
    methods: {
        closeModal: function () {
            this.$emit('modal-closed');
            $('#studentGroupStudentsModal').modal('hide');
        },
    }
}
</script>

<style scoped>
.fixed-height {
    max-height: 400px;
    overflow-y: auto;
}
</style>
